export enum FormFieldKeyConditionTypeEnum {
    Any = 1,
    All = 2,
}